<template>
	<div>
		<div class="mynav">
			<div class="logoDiv">
				<a href='./'>
					<img id="logo" src="../../assets/logo.png">
				</a>
			</div>
			<div class="navbar" id="myTopnav">
				<ul>
					<li v-for="(tab,index) in tabs" :key="index">
						<router-link :to="tab[0]" :class="{active: selected == index}">{{tab[1]}}</router-link>
					</li>
					<li>
						<a href="https://shop1257882911.v.weidian.com/?userid=1257882911&spider_token=0c73" target="_blank">音书小店</a>
					</li>
					<li>
						<a href="https://pro.voibook.com" target="_blank">字幕速记</a>
					</li>
					<li class="icon">
						<a href="#"  @click="showOptions($event)">&#9776;</a>
					</li>
				</ul>
			</div>
		</div>
		<div class="responsive">
			<ul>
				<li v-for="(tab,index) in tabs" :key="index" v-on:click="selected = index">
					<router-link :to="tab[0]" :class="{active: selected === index}">{{tab[1]}}</router-link>
				</li>
				<li>
					<a href="https://shop1257882911.v.weidian.com/?userid=1257882911&spider_token=0c73" target="_blank">音书小店</a>
				</li>
				<li>
					<a href="https://pro.voibook.com" target="_blank">字幕速记</a>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
import bus from '@/lib/bus.js'
import './nav.css'
export default {
	name: 'navigationBar',
	data () {
		return {
			selected: 0,
			tabs: [
				['/', '首页'],
				['/product/personal/none', '产品'],
				['/video/0', '视频教程'],
				['/aboutUs/none', '关于我们'],
				['/news', '新闻动态']
			]
		}
	},
	mounted () {
		let currPath = this.$route.path
		this.selected = this.tabs.map(it => it[0].slice(1)).findIndex(it => it === currPath)

		bus.$on('changeSelectedIndex', (idx) => {
			this.selected = idx || 0
		})
	},
	methods: {
		showOptions: function (evt) {
			var acc = document.getElementsByClassName('navbar')
			var i

			for (i = 0; i < acc.length; i++) {
				acc[i].className = acc[i].className.replace(' active', '')
			}
			// evt.currentTarget.className += 'active1';
			var panel = document.getElementsByClassName('responsive')[0]
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null
			} else {
				panel.style.maxHeight = panel.scrollHeight + 'px'
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/common/navigationBar.vue